var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex flex-column items-center justify-center text-white text-center"},[_c('div',{staticClass:"w-34 mx-auto pl-4"},[_c('LogoSVG',{staticClass:"inline-block fill-white events-none w-full"})],1),_c('div',{staticClass:"text-tiny font-bold mt-1"},[_vm._v(_vm._s(_vm.$t('logo')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }